// import { App } from 'containers';
/* global _CLIENT_ */

function errorLoading(err) {
  console.error('Dynamic page loading failed', err);
}

function loadRoute(cb) {
  return (module) => cb(null, module.default);
}

const routes = {
  component: '',
  childRoutes: [
    {
      path: '/addressInput',
      getComponent(location, cb) {
        System.import('containers/AddressForm/AddressForm')
          .then(loadRoute(cb))
          .catch(errorLoading);
      }
    },
    {
      path: '/addressForm-v2',
      getComponent(location, cb) {
        System.import('containers/AddressForm/AddressForm')
          .then(loadRoute(cb))
          .catch(errorLoading);
      }
    },
    {
      path: '/addressEditor',
      getComponent(location, cb) {
        System.import('containers/AddressForm/AddressFormEditor')
          .then(loadRoute(cb))
          .catch(errorLoading);
      }
    },
    {
      path: '/addressInputFree',
      getComponent(location, cb) {
        System.import('containers/AddressForm/AddressFormFree')
          .then(loadRoute(cb))
          .catch(errorLoading);
      }
    },
    {
      path: '/addressFormFree-v2',
      getComponent(location, cb) {
        System.import('containers/AddressForm/AddressFormFree')
          .then(loadRoute(cb))
          .catch(errorLoading);
      }
    },
    {
      path: '/',
      getComponent(location, cb) {
        System.import('containers/App/App')
          .then(loadRoute(cb))
          .catch(errorLoading);
      },
      indexRoute: {
        getComponent(location, cb) {
          System.import('containers/Home/Home')
            .then(loadRoute(cb))
            .catch(errorLoading);
        }
      },
      childRoutes: [
        {
          path: '/login',
          getComponent(location, cb) {
            System.import('containers/Login/Login')
              .then(loadRoute(cb))
              .catch(errorLoading);
          }
        },
        {
          path: '/*',
          getComponent(location, cb) {
            System.import('containers/NotFound/NotFound')
              .then(loadRoute(cb))
              .catch(errorLoading);
          }
        },
      ]
    }
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./Scripts/routes.js